var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Tools50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M12.3,40.8c0.1-0.1,1.3-1.4,3.2-3.4c2.8-2.9,15-15.9,15.2-16.1c0.9-0.9,5.2,2.4,8.8-1.2c2.3-2.3,3.1-5.2,2.1-8.7L37,16c0,0-1.7,0-3.4-1.6C32,12.7,32,11,32,11l4.6-4.5c-3.3-1-6.5-0.2-8.8,2.1c-3.5,3.5-0.4,7.9-1.3,8.8C26.3,17.5,9.2,33.8,9,34l0,0c-1.7,1.6-1.8,1.7-1.9,1.7C5.7,37.2,5.6,39.6,7,41C8.4,42.4,10.8,42.3,12.3,40.8z M10,36.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S9.1,36.5,10,36.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M40,37L14.5,11.7L12,8L7.4,6L6,7.4L8,12l3.7,2.5l25.5,25.3L40,37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M26.5,20.8c-2.1-5-3.3-2.3-5.7,0l0,0c-2.3,2.3-5,3.5,0,5.7c4.9,2.1,10.3,11.7,12.4,13.9c2.1,2.1,4.7,2.3,7.1,0l0,0c2.3-2.3,2.1-4.9,0-7.1C38.2,31.2,28.6,25.8,26.5,20.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M20.8,20.8c2.3-2.3,3.5-5,5.7,0l-5.7,5.7C15.9,24.4,18.5,23.2,20.8,20.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Tools50);
export default __webpack_public_path__ + "static/media/icons8-tools-50.0f03cdfddcc644d683a511ad09113e7d.svg";
export { ForwardRef as ReactComponent };